/**
 * Normalizes a string capitalizing the first letter and making the rest lowercase.
 * @param {string} text The string to normalize
 * @return {string} 	A string in which the first letter of each word is in Uppercase and the rest is in lowercase.
 */
export const normalizeText = (text: String) => {
	let substrings = text.trim().split(' ');

	const normalizedText = substrings.map((substring) => {
		let auxString =
			substring.charAt(0).toUpperCase() +
			substring.slice(1).toLowerCase();
		return auxString;
	});

	return normalizedText.join(' ');
};
